import parse from 'date-fns/parse';

export default function(
  date: Date | string | number,
  options?: { additionalDigits?: 0 | 1 | 2 }
) {
  return parse(date, options);
}
